module.exports = __webpack_public_path__ + "static/media/8.24038c2b.svg";